// The quote flow's secondary button vocabulary, beside FormV2's
// CONTINUE_BUTTON_CLASS (the primary). Both families stand on FormV2's
// BUTTON_BOX_CLASS — the same border, padding, radius and gap — so the same
// label is the same size in either; only the colors differ.

import { BUTTON_BOX_CLASS } from "components/FormV2";

export const LINK_BUTTON_CLASS =
  "inline-flex items-center gap-2 bg-transparent p-0 font-bold text-evergreen underline underline-offset-4 transition-colors hover:text-plum";

export const OUTLINE_BUTTON_CLASS = `${BUTTON_BOX_CLASS} border-soil bg-transparent text-soil hover:border-cantelope hover:bg-cantelope`;
